import * as Sentry from '@sentry/react';
import { QueryCache, QueryClient } from '@tanstack/react-query';

import { handleSessionExpired } from '../auth';

import {
  AuthTokenUnavailableError,
  SessionExpiredError,
} from './fetchWithAuthHeaders';

// These already emit an intentional `auth.session_expired` message from
// fetchWithAuthHeaders, so re-capturing them here would double-report.
const isReportedAuthError = (error: unknown): boolean =>
  error instanceof SessionExpiredError ||
  error instanceof AuthTokenUnavailableError;

// SpecRef: ARCH-005
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#2-global-querycacheonerror
// Single capture point for all TanStack Query failures; no per-hook error handling needed.
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: error => {
      // Recover a lost auth session (loop-guarded) instead of freezing.
      // handleSessionExpired never rejects, but guard the fire-and-forget so a
      // future change can't leak an unhandled rejection.
      void handleSessionExpired(error).catch(handlerError =>
        Sentry.captureException(handlerError),
      );
      if (!isReportedAuthError(error)) {
        Sentry.captureException(error);
      }
    },
  }),
});
